export default __webpack_public_path__ + "static/media/kg78l96z@2x.3545bdec.png";